import { FiltroMapaDeChuvas } from "../typings";

export type MapaDeChuvaPeriodFilter = Pick<
  FiltroMapaDeChuvas,
  "periodo" | "dataInicial" | "dataFinal" | "horaInicial" | "horaFinal"
>;

export function toMapaDeChuvaPeriodFilter(
  filtro: FiltroMapaDeChuvas | null | undefined
): MapaDeChuvaPeriodFilter | null {
  if (!filtro) {
    return null;
  }

  return {
    periodo: filtro.periodo,
    dataInicial: filtro.dataInicial,
    dataFinal: filtro.dataFinal,
    horaInicial: filtro.horaInicial,
    horaFinal: filtro.horaFinal,
  };
}

export function buildMapaDeChuvaPeriodQueryKey(
  filtro: FiltroMapaDeChuvas | null | undefined,
  setorId?: string | null,
  allIndexCodes?: number[] | null
): (string | number | null | undefined)[] {
  const period = toMapaDeChuvaPeriodFilter(filtro);

  return [
    "mapa-de-chuva-period",
    period?.periodo,
    period?.dataInicial,
    period?.dataFinal,
    period?.horaInicial,
    period?.horaFinal,
    setorId ?? null,

    allIndexCodes?.length ? [...allIndexCodes].sort((a, b) => a - b).join(",") : null,
  ];
}
